export default __webpack_public_path__ + "static/checknlearn-promo-small@2x-7ff3a8944576d1f3136831b020f63e3b.webp";